<rt-dialog width="420px" i18n-ariaLabel="@@signInDialogLabel" ariaLabel="Вход">
    <div rtBlock="sc-sign-in-modal" qa-dataid="sign-in-window">
        <h2 rtElem="title" i18n="@@signInTitle">Нужен вход</h2>
        <p rtElem="text" i18n="@@signInDescription">Сохранение проекта и доступ к сохранённым проектам требуют входа.</p>
        <div rtElem="actions">
            <button rtButton appearance="outlined" type="button" qa-dataid="sign-in-cancel" i18n="@@signInCancel" (click)="cancel()">
                Отмена
            </button>
            <button rtButton type="button" qa-dataid="sign-in-confirm" i18n="@@signInConfirm" (click)="confirm()">Войти</button>
        </div>
    </div>
</rt-dialog>
